import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class PickupStore {

  private _pickupData:Array<Object>;
  set pickupData(pickup:Array<Object>){
    this._pickupData = pickup;
  }
  get pickupData(){
    return this._pickupData;
  }
}



// WEBPACK FOOTER //
// ./src/stores/pickup-store.ts